import { type DiagnosticDefinitionDto, useDiagnosticDefinition } from "@repo/data-store";
import { createFileRoute } from "@tanstack/react-router";
import { CatalogDefinition, DiagnosticRead } from "@/features/catalog";
import { useDefinitionChangePoints, useDefinitionView } from "@/features/catalog/hooks/use-definition-as-of";
import { asOfSearchSchema } from "@/features/catalog/lib/as-of-search";
import { diagnosticDefinitionUrlFromRouteId } from "@/features/catalog/lib/diagnostic-definition-route";

export const Route = createFileRoute("/catalog/diagnostics/$diagnosticId")({
  component: DiagnosticDetail,
  validateSearch: asOfSearchSchema,
});

function DiagnosticDetail() {
  const { diagnosticId } = Route.useParams();
  const { asOf } = Route.useSearch();
  const { permissions } = Route.useRouteContext();
  const definitionUrl = diagnosticDefinitionUrlFromRouteId(diagnosticId);
  const live = useDiagnosticDefinition(asOf ? undefined : definitionUrl);
  const view = useDefinitionView<DiagnosticDefinitionDto>(definitionUrl, asOf, live);
  const { changePoints } = useDefinitionChangePoints(definitionUrl);

  if (view.isPending) return <CatalogDefinition.Pending />;
  if (!view.definition) {
    return (
      <CatalogDefinition.NotFound label="Diagnostic" backTo="/catalog/procedures" backLabel="Back to procedures" />
    );
  }

  return (
    <DiagnosticRead
      key={`${diagnosticId}|${asOf ?? "latest"}`}
      definition={view.definition}
      diagnosticId={diagnosticId}
      asOf={asOf}
      changePoints={changePoints}
      canEdit={!view.isPast && permissions.canWrite("ActivityDefinition")}
    />
  );
}
